import styled from 'styled-components';

export const Container = styled.div``;

export const SearchButton = styled.button``;

export const IconContainer = styled.div``;